import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useTicTacToeStore from "../lib/stores/ticTacToesStore";
import Info from "./Info/Info";
import { Switch } from "./Switch";
const Sidebar = () => {
    const { gameMode, setIsXNext, setMoveOrder, setSquares, toggleGameMode } = useTicTacToeStore();
    const handleReset = () => {
        setSquares(Array(9).fill(null));
        setMoveOrder([]);
        setIsXNext(true);
    };
    const handleToggleMode = () => {
        toggleGameMode();
        handleReset();
    };
    return (_jsxs("div", { className: "flex items-center space-x-2 pt-4 pb-20 lg:py-[325px]", children: [_jsx(Info, {}), _jsx(Switch, { onCheckedChange: handleToggleMode, checked: gameMode === "threeMoves", id: "game-mode" }), _jsxs("label", { htmlFor: "game-mode", className: "whitespace-nowrap cursor-pointer", children: ["Switch to ", gameMode === "resetMode" ? "Three Moves Mode" : "Reset Mode"] })] }));
};
export default Sidebar;
